import { gql } from "@apollo/client";

export const GET_PORTALROLE = gql`
  query portalRole {
    portalRole {
      Id
      roleName
    }
  }
`;
export const UPDATE_PORTALROLE = gql`
  mutation updatePortalRole($input: updatePortalRoleInput) {
    updatePortalRole(input: $input)
  }
`;
